import React, { useState, useEffect } from 'react'

import ModalComponent from "../../../../../../components/modal-component/modal-component"
import { Button } from "../../../../../../components/button/button"
import { GiveAccessModalBodyStyled } from './give-access-modal.styles'
import { Typography } from '@mui/material'
import { ACCOUNT_STATUSES } from '../../../../../../constants'
import { useAppDispatch } from '../../../../../../store/hooks'
import { addNotification } from '../../../../../../store/slices/ui-slice'
import { v4 as uuid } from "uuid"
import { GiveAccessModalProps } from './types'
import { useUpdateUserStatusMutation } from '../../../../../../generated/graphql'



const ModalBody: React.FC<GiveAccessModalProps> = ({ refetch, data, onClose }) => {
    const dispatch = useAppDispatch()
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [updateUserStatus] = useUpdateUserStatusMutation({
        variables: {
            id: `${data.id}`,
            status: ACCOUNT_STATUSES.ACTIVE
        }
    })

    const handleConfirm = async () => {
        try {
            setIsLoading(true)
            await updateUserStatus()
            refetch && refetch()
            dispatch(
                addNotification({
                    id: uuid(),
                    type: "success",
                    message: "Account access has been given successfully.",
                })
            )
            onClose && onClose()
        } catch (err: any) {
            dispatch(
                addNotification({
                    id: uuid(),
                    type: "error",
                    message: err?.message,
                })
            )
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <GiveAccessModalBodyStyled>
            <Typography className="content">
                Are you sure to give access of {data.first_name || data.last_name ? <b>{`${data.first_name} ${data.last_name}`.trim()}’s</b> : ''} account {data.email}?
            </Typography>
            <Button onClick={handleConfirm} isLoading={isLoading} className="confirm-button">Confirm</Button>
        </GiveAccessModalBodyStyled>
    )
}

const GiveAccessModal: React.FC<GiveAccessModalProps> = ({ refetch, data, onClose }) => {
    const [openModal, setOpenModal] = useState<boolean>(false)

    useEffect(() => {
        setOpenModal(true)
    }, [])

    const handleClose = () => {
        setOpenModal(false)
        onClose && onClose()
    }

    return (
        <div>
            <ModalComponent
                title="Give Access"
                content={<ModalBody data={data} refetch={refetch} onClose={handleClose} />}
                open={openModal}
                onClose={handleClose}
            />
        </div>
    )
}

export default GiveAccessModal
